export const GET_LOGGEDIN_USERS = 'getLoggedInUsers';
export const SEND_TO_MAIN = 'sendToMain';
export const VIEW_READY = 'viewReady';
export const PARTITION_MIGRATION_USER_CONTEXT = 'partitionMigrationUserContext';
export const UPDATE_WEBVIEW_URL = 'updateWebviewURL';
export const SHELL_RELOAD = 'shellReload';
export const GET_PARTITION_ID = 'getPartitionId';
